/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, Label as LabelCore, type LabelProps as LabelCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { mergeStyles } from '../../utils/merge-styles/merge-styles.util';

interface LabelProps extends Omit<LabelCoreProps, 'style' | 'className'> {
  /** The size variant of the label. (Default: 16) */
  size?: keyof typeof sizeVariants,
  /** The color variant of the label. (Default: primary) */
  color?: keyof typeof colorVariants,
  style?: stylex.StyleXStyles;
}

const LabelContext = createContext<ContextValue<LabelProps, HTMLLabelElement>>({});

const Label = forwardRef(({ style: styleProp, ...mergedProps }: LabelProps, ref: ForwardedRef<HTMLLabelElement>) => {
  [mergedProps, ref] = useContextProps(mergedProps, ref, LabelContext);

  const { style: contextStyle, size = 16, color = 'primary', ...coreProps } = mergedProps as LabelProps;

  return (
    <LabelCore
      ref={ref}
      {...stylex.props(
        styles.base,
        sizeVariants[size],
        colorVariants[color],
        mergeStyles(contextStyle, styleProp)
      )}
      {...coreProps}
    />
  );
});

const styles = stylex.create({
  base: {
    fontFamily: "Inter",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontStyle: "normal",
    fontWeight: 400,
  }
});

const colorVariants = stylex.create({
  primary: { color: $.textPrimary },
  secondary: { color: $.textSecondary },
  tertiary: { color: $.textTertiary },
  quaternary: { color: $.textQuaternary },
  placeholder: { color: $.textPlaceholder },
  disabled: { color: $.textDisabled },
  inverted: { color: $.textInverted },
  interactive: { color: $.textInteractive },
  interactiveHover: { color: $.textInteractiveHover },
  positive: { color: $.textPositive },
  positiveHover: { color: $.textPositiveHover },
  critical: { color: $.textCritical },
  criticalHover: { color: $.textCriticalHover },
  white: { color: $.textWhite },
  black: { color: $.textBlack },
});

const sizeVariants = stylex.create({
  12: {
    fontSize: 12,
    letterSpacing: -0.4,
  },
  13: {
    fontSize: 13,
    letterSpacing: -0.4,
  },
  14: {
    fontSize: 14,
    letterSpacing: -0.45,
  },
  16: {
    fontSize: 16,
    letterSpacing: -0.5,
  },
  18: {
    fontSize: 18,
    letterSpacing: -0.5,
  }
});

export { Label, LabelContext, type LabelProps };
